import React from "react";
import { string, node, bool, number } from "prop-types";
import cx from "classnames";
import PlusIcon from "../PlusIcon/PlusIcon.jsx";

const propTypes = {
  title: string.isRequired,
  children: node,
  isOpen: bool,
  breakpoint: number,
  is5050: bool,
  description: node,
};

const Accordion = (props) => {
  const { title, children, isOpen, breakpoint, is5050, description } = props;

  return (
    <section
      className={cx("accordion component js-accordion", {
        "is-open": isOpen,
        "accordion--50-50": is5050,
        "accordion--with-description": description,
      })}
      data-accordion-breakpoint={breakpoint}
    >
      <div className="accordion__title">
        <button
          className="btn accordion__toggle js-accordion-link"
          type="button"
        >
          {title}
          <PlusIcon />
        </button>
        {description && (
          <div className="accordion__description-desktop">{description}</div>
        )}
      </div>
      <div className="accordion__content js-accordion-content">
        {description && (
          <div className="accordion__description-mobile">{description}</div>
        )}
        {children}
      </div>
    </section>
  );
};

Accordion.propTypes = propTypes;
export default Accordion;
